import React from 'react';
interface LogoProps {
  onClick?: () => void;
  className?: string;
}

/**
 * The wordmark: the name set in mono with a single signal-coloured
 * full stop. Restrained enough for an institutional masthead.
 */
export function Logo({
  onClick,
  className = ''
}: LogoProps) {
  return <button onClick={onClick} aria-label="Alex Circei — back to top" className={`whitespace-nowrap font-mono text-[12px] font-medium uppercase tracking-[0.16em] text-ink transition-colors duration-200 ease-editorial hover:text-signal ${className}`} data-id="element-103" data-mp="3v8eg2vk611on">
      Alex Circei<span className="text-signal" data-id="element-104" data-mp="rpl3akz7ogvj">.</span>
    </button>;
}